import { createDictionary } from 'utils/utils';
import { APPOINTMENT_STATUSES } from 'modules/entity/subEntities/appointment/constants';
import { INTERVENTION_STATUS } from 'modules/entity/subEntities/intervention/constants';

import { PATH, PATH_NAME } from './Routes';

/** @typedef {'APPOINTMENT' | 'CAMPAIGN_FILE' | 'INTERVENTION' | 'AUDIT' | 'CUSTOMIZE'} EntityType */
const ENTITIES = {
  APPOINTMENT: 'APPOINTMENT',
  CAMPAIGN_FILE: 'CAMPAIGN_FILE',
  INTERVENTION: 'INTERVENTION',
  AUDIT: 'AUDIT',
  CUSTOMIZE: 'CUSTOMIZE',
};

const PATH_TO_ENTITIES = {
  [ENTITIES.AUDIT]: [PATH_NAME.AUDIT],
  [ENTITIES.CAMPAIGN_FILE]: [PATH_NAME.CAMPAIGN, PATH_NAME.CAMPAIGN_FILE],
  [ENTITIES.CUSTOMIZE]: [PATH_NAME.CUSTOMIZE],
  [ENTITIES.APPOINTMENT]: [PATH_NAME.APPOINTMENT],
  [ENTITIES.INTERVENTION]: [PATH_NAME.FOLLOW_UP, PATH_NAME.INTERVENTION, PATH_NAME.INTERVENTION_ENTITIES],
};

const TEST_PAGES_BY_ENTITY = {
  [ENTITIES.AUDIT]: ['audit'],
  [ENTITIES.CUSTOMIZE]: ['customize'],
  [ENTITIES.APPOINTMENT]: ['appointment'],
  [ENTITIES.INTERVENTION]: ['aftersales', 'sales', 'parts', 'follow-up'],
  [ENTITIES.CAMPAIGN_FILE]: ['campaign-aftersales', 'campaign-sales', 'campaign-parts'],
};

export const READ_ONLY_STATUSES = createDictionary(
  {
    [ENTITIES.APPOINTMENT]: [APPOINTMENT_STATUSES.CLOSED, APPOINTMENT_STATUSES.DELETED],
    [ENTITIES.INTERVENTION]: [INTERVENTION_STATUS.CLOSED, INTERVENTION_STATUS.DELETED],
  },
  []
);

/**
 * @param {import('./EntityConstants').EntityType} entityType
 * @returns {boolean}
 */
const isEntity = (entityType) =>
  PATH_TO_ENTITIES[entityType]?.some((path) => PATH[path]?.match(window.location.pathname)) ||
  (PATH[PATH_NAME.TEST].match(window.location.pathname) &&
    TEST_PAGES_BY_ENTITY[entityType]?.some((page) => window.location.pathname.includes(page)));

/**
 * @returns {import('./EntityConstants').EntityType}
 */
export const getEntityType = () => Object.values(ENTITIES).find((type) => isEntity(type));

export const isAudit = isEntity(ENTITIES.AUDIT);
export const isCustomize = isEntity(ENTITIES.CUSTOMIZE);
export const isAppointment = isEntity(ENTITIES.APPOINTMENT);
export const isIntervention = isEntity(ENTITIES.INTERVENTION);
export const isCampaign = isEntity(ENTITIES.CAMPAIGN_FILE) || isEntity(ENTITIES.CAMPAIGN);
